import { I18n } from '@calendly/i18n';
import { TitleText } from '@calendly/ui/components/typography';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useEffect, forwardRef } from 'react';
import { BOOKING_METHODS } from '../constants';
import { ProgressBar } from './progress_bar';
import { CloseButton, NavigatorItems, NavigatorWrapper } from './styles';
const centeredProgressBarIsTabletUpCss = "c1td0rqe";
const centeredProgressBarShouldCenterCss = "c1583tgl";
const centeredProgressBarCss = "cvdy3ig";
const CenteredProgressBar = forwardRef((props, ref) => {
  const {
    shouldCenter
  } = props;
  const isTabletUp = useDeviceType('isTabletUp');
  return <ProgressBar ref={ref} {...props} className={classNames(centeredProgressBarCss, {
    [centeredProgressBarIsTabletUpCss]: isTabletUp,
    [centeredProgressBarShouldCenterCss]: shouldCenter
  }, props.className)} />;
});
export const Navigator = ({
  currentTab,
  stepName,
  bookingMethod,
  editing,
  onClose
}) => {
  useEffect(() => {
    document.activeElement.blur();
  }, []);
  return <NavigatorWrapper stepName={stepName} useUpdatedDesign>
      <NavigatorItems>
        <TitleText level={2} as="h1" size="medium">
          {bookingMethod === BOOKING_METHODS.poll ? I18n.t(`publisher.event_types.one_off.creation_modal.headers.${editing ? 'edit_' : ''}meeting_poll`) : I18n.t('publisher.event_types.one_off.creation_modal.headers.one_off')}
        </TitleText>
        <CenteredProgressBar shouldCenter={stepName !== 'details_step'} currentTab={currentTab} useNarrow={stepName === 'details_step'} />
        <CloseButton onClick={onClose} size="x-large" />
      </NavigatorItems>
    </NavigatorWrapper>;
};
Navigator.propTypes = {
  currentTab: PropTypes.number.isRequired,
  stepName: PropTypes.string.isRequired,
  bookingMethod: PropTypes.string.isRequired,
  editing: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};

// i18n-tasks-use t('publisher.event_types.one_off.creation_modal.details_step.modal_header.one_off_meeting')
// i18n-tasks-use t('publisher.event_types.one_off.creation_modal.time_step.modal_header.one_off_meeting')
// i18n-tasks-use t('publisher.event_types.one_off.creation_modal.share_step.modal_header.one_off_meeting')
// i18n-tasks-use t('publisher.event_types.one_off.creation_modal.headers.edit_meeting_poll')
// i18n-tasks-use t('publisher.event_types.one_off.creation_modal.headers.meeting_poll')

// i18n-tasks-use t('publisher.event_types.one_off.creation_modal.details_step.modal_header.meeting_poll')
// i18n-tasks-use t('publisher.event_types.one_off.creation_modal.time_step.modal_header.meeting_poll')
// i18n-tasks-use t('publisher.event_types.one_off.creation_modal.share_step.modal_header.meeting_poll')
// i18n-tasks-use t('publisher.event_types.one_off.creation_modal.details_step.modal_header.edit_meeting_poll')
// i18n-tasks-use t('publisher.event_types.one_off.creation_modal.time_step.modal_header.edit_meeting_poll')

require("./navigator.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./navigator.js");